import React, { useState, useEffect, useMemo, useCallback, useContext } from 'react'
import { Prompt } from 'react-router'
import Loading from './Loading'
import { FormGroup, Label } from 'reactstrap'
import Input from './Input'
import Button from './Button'
import AmazonSelector from './AmazonSelector'
import ArticleResourcesContent from './ArticleResourcesContent'
import ArticleResourcesColumn from './ArticleResourcesColumn'
import { If, urlText } from '../modules/helpers'
import { get, post, put } from '../modules/fetch'
import model_array from '../modules/model_array'
import { format, parseISO, isValid, subYears } from 'date-fns'
import lscache from 'lscache'
import Icon from './Icon'
import useTranslation from '../hooks/useTranslation'
import { DEEPL_LOCALE, ARTICLE_STATUS_ARRAY } from '../constants/'
import Switch from './Switch'
import ArticleStatus from './ArticleStatus'
import useData from '../hooks/useData'
const uuidv4 = require('uuid/v4')

export const Sort_array = [
    { label: 'Relevance', icon: 'relevance', value: 'Relevance', default: true },
    // { label: 'Sales Rank', icon: 'salesrank', value: 'salesrank' },
    { label: 'Featured', icon: 'salesrank', value: 'Featured' },
    { label: 'Price', icon: 'price', value: 'HighToLow' },
    { label: '-Price', icon: 'price_desc', value: 'LowToHigh' },
    // { label: 'Review Rank', icon: 'reviewrank', value: 'reviewrank' },
    // { label: 'Review Rank Authority', icon: 'reviewrank_authority', value: 'reviewrank_authority' }
    { label: 'NewestArrivals', icon: 'reviewrank', value: 'NewestArrivals' },
    { label: 'AvgCustomerReviews', icon: 'reviewrank', value: 'AvgCustomerReviews' },
]

let diff_id = uuidv4()
let last_saved_diff_id = diff_id
const getCachedVersion = (id) => lscache.get('article-' + id)

export const ArticleEditContext = React.createContext({})
// const are_you_sure = (e) => {
//     var confirmationMessage = "\o/"
//     (e || window.event).returnValue = confirmationMessage     //Gecko + IE
//     return confirmationMessage                                //Webkit, Safari, Chrome etc.
// }

const getGetParam = (url, param) => {
    let value = null
    if (url && !!url.indexOf(param + '=')) {
        const url_obj = new URL(url)
        value = url_obj.searchParams.get(param)
    }
    return value
}

const isRoot = (b) => b.type === 'root'
const isNotRoot = (b) => !isRoot(b)
const isPlaceholder = (b) => b.type === 'placeholder'
const isNotPlaceholder = (b) => !isPlaceholder(b)

let timer = null

export const TranslationContext = React.createContext({})

const ArticleEdit = function ArticleEdit(props) {
    const model = 'article'
    const form_definition = model_array.find((model_object) => model_object.name === model).form_definition
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false

    const [status, setStatus] = useState((id && 'fetching') || 'ready')
    const [draft_status, setDraftStatus] = useState((id && 'fetching') || 'ready')
    const form_data_default = (id && { id }) || {}
    const [form_data, setFormData] = useState(form_data_default)
    const [needs_to_be_saved, setNeedsToBeSaved] = useState(false)
    const [article, setArticle] = useState({})
    const [query_history, setQueryHistory] = useState((localStorage.getItem('query_history') && JSON.parse(localStorage.getItem('query_history'))) || [])
    // console.log({query_history})
    const [product_bucket_array, setProductBucketArray] = useState(
        (localStorage.getItem('product_search_array') && JSON.parse(localStorage.getItem('product_search_array'))) || []
    )
    const [display_amazon_selector, setAmazonSelectorVisible] = useState(false)
    const [expanded_draft_list, setExpandedDraftList] = useState(false)
    const [unavailable_link_array, setUnavailableLinkArray] = useState(false)

    const clickData = useData('click?article_id=' + id + '&start_date=' + format(subYears(new Date(), 1), 'yyyy-MM-dd'), [id])

    const unavailableLinkData = useData('provider/amazon/unavailable_links?scope=list&article_id=' + id, [id])
    // console.log({ unavailableLinkData })

    const breadcrumb_data = []
    article &&
        article.site &&
        article.site.label &&
        breadcrumb_data.push({ icon: 'site', label: article.site.label || '', href: '/site/view/' + (article.site.id || '') })
    article && article.title && breadcrumb_data.push({ icon: 'article', label: article.title, href: '/article/edit/' + article.id })

    useMemo(() => {
        if (article?.body) {
            const body = JSON.parse(article?.body)
            const root = body.find((b) => b.type === 'root')

            const hasParent = (block) => !!body.find((b) => b.block_id_array?.includes(block.id))
            const hasNoParent = (block) => !hasParent(block)

            const valid_block_array = body.filter(isNotRoot).filter(isNotPlaceholder).filter(hasParent)
            const invalid_block_array = body.filter(isNotRoot).filter(isNotPlaceholder).filter(hasNoParent)
            // const valid_block_array = body.filter(b => b.type!=='root').filter(b => body.find(_b => _b.block_id_array?.find(_bid => b.id)))

            invalid_block_array.length && console.error('Blocks to be deleted', invalid_block_array)
        }
    }, [article?.body])

    const { translate } = useTranslation()

    const translateText = ({ text, source_locale, target_locale }) => {
        return new Promise((resolve, reject) => {
            translate({
                text,
                source_lang: DEEPL_LOCALE[source_locale] || undefined,
                target_lang: DEEPL_LOCALE[target_locale],
                tag_handling: 'xml',
            })
                .then((result) => {
                    console.log(result.data)
                    resolve({ text: result.data.translations[0]?.text })
                    refreshTranslationUsage && refreshTranslationUsage()
                })
                .catch(console.error)
        })
    }

    const cache = () => {
        lscache.set(
            'article-' + id,
            Object.keys(form_data).reduce((acc, key) => {
                if (typeof form_data[key] === 'object') {
                    acc[key] = JSON.stringify(form_data[key])
                } else {
                    acc[key] = form_data[key]
                }
                return acc
            }, {}),
            60 * 24 * 3
        )
    }
    const cached_version = getCachedVersion(id)

    /* const cacheVersion = useEffect(() => {
        let local_diff_id = diff_id
        timer = setInterval(() => {
            if (local_diff_id !== diff_id) {
                console.log('cacheVersion() called')
                local_diff_id = diff_id
                cache()
                saveDraft()
            }
        }, 1000 * 60 * 5)
        return () => {
            clearInterval(timer)
        }
    }, []) */
    const restoreCachedVersion = () => {
        const { timestamp, ...rest } = cached_version
        console.log(rest)
        setFormData(rest)
    }

    // const unloadcheck = useEffect(() => {
    //     window.addEventListener("beforeunload", are_you_sure)
    //     return () => window.addEventListener("beforeunload", are_you_sure)
    // })

    let get_article_draft_id = getGetParam(window.location.href, 'article_draft_id')
    useEffect(() => {
        if (id) {
            const article_draft_id_param = (get_article_draft_id && '&article_draft_id=' + get_article_draft_id) || ''
            get(model + '/' + id + '?scope=edit' + article_draft_id_param)
                // .then(r => r.json())
                .then((r) => console.log(r) || r)
                .then((r) => {
                    const article_draft = r.article_draft || null
                    let data_target = r
                    if (get_article_draft_id) {
                        data_target = article_draft
                        console.log('loading article_draft', get_article_draft_id)
                    } else if (article_draft) {
                        // const article_draft_updated_time = article_draft.updated_at.replace('-', '').replace(' ', '').replace(':', '')
                        // const article_updated_time = r.updated_at.replace('-', '').replace(' ', '').replace(':', '')
                        // console.log(article_updated_time, article_draft_updated_time, (article_updated_time >= article_draft_updated_time&&'taking article'||'taking article_draft', article_draft))
                        // data_target = article_updated_time >= article_draft_updated_time && r || article_draft
                    } else {
                        console.log('no article_draft')
                    }
                    const _form_data = Object.assign(
                        {},
                        form_definition.reduce((acc, property) => {
                            console.log('setting', property.name)
                            acc[property.name] = data_target[property.name]
                            return acc
                        }, form_data_default)
                    )
                    // console.log(form_definition, _form_data)
                    if (typeof r.resources === 'string') {
                        r.resources = (r.resources && JSON.parse(r.resources)) || []
                    }
                    setArticle(r)
                    setFormData(_form_data)
                    setStatus('ready')
                    setDraftStatus('ready')
                    cache()
                })
            // get('provider/amazon/unavailable_links?scope=list')
            // .then((r) => setUnavailableLinkArray(r) || r)
            // .then(console.log)
        }
    }, [id])

    const setFormDataState = (e) => {
        diff_id = uuidv4()
        // console.log({last_saved_diff_id}, {diff_id})
        const value = e.target.name === 'permalink' ? urlText(e.target.value) : e.target.value
        setFormData({ ...form_data, [e.target.name]: value })
        setNeedsToBeSaved(true)
        setStatus('ready')
        setDraftStatus('ready')
        // console.log('setFormDataState', e.target)
        // console.log('setFormDataState called')
    }
    const setComputedFormDataState = (e) => {
        setFormData({ ...form_data, [e.target.name]: e.target.value })
        // console.log('setFormDataState', e.target)
    }

    const setPublished = (published) => {
        setArticle({ ...article, published })
        // const url = ((id && model + '/' + id) || model) + '?scope=edit'
        // const request = (id && put) || post
        // request(url, { published }).then((r) => r.json())
        // .then(r => {  })
        return false
    }
    const setArticleStatus = (status_id) => {
        setArticle({ ...article, status_id: status_id })
        return false
    }
    const save = async (e) => {
        console.log('save')
        e.preventDefault()
        last_saved_diff_id = uuidv4()
        diff_id = last_saved_diff_id
        // console.log({last_saved_diff_id}, {diff_id})
        setStatus('loading')
        if (props.location.search && !!props.location.search.indexOf('site_id=')) {
            const url = new URL(window.location.href)
            const site_id = url.searchParams.get('site_id')
            form_data.site_id = site_id
        }
        // console.log(form_data)
        const url = ((id && model + '/' + id) || model) + '?scope=edit'
        const request = (id && put) || post
        // console.log(form_data)
        const data = { ...form_data }
        let body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body
        // remove orphans
        const hasParent = (block) => body.find((item) => item.type === 'root' || (item.block_id_array && ~item.block_id_array.indexOf(block.id)))
        body = body.filter(hasParent)
        data.body = body.filter(Boolean).map((block) => {
            let _block = block
            if (block && block.payload) {
                _block = { ...block, payload: undefined }
            }
            return _block
        })
        if (typeof data.resources === 'object') {
            data.resources = JSON.stringify(data.resources)
        }
        data.published = article.published
        data.status_id = article.status_id
        request(
            url,
            Object.keys(data).reduce((acc, key) => {
                if (typeof data[key] === 'object') {
                    acc[key] = JSON.stringify(data[key])
                } else {
                    acc[key] = data[key]
                }
                return acc
            }, {})
        ).then(async (r) => {
            if (onSaveArray.length) {
                for (const req of onSaveArray) {
                    const { method, url, params } = req
                    await method(url, params)
                }
            }
            setStatus('saved')
            setNeedsToBeSaved(false)
            setArticle({ ...r, site_id: article.site_id, site: article.site, article_draft_array: article.article_draft_array })
            if (props.location.search && !!props.location.search.indexOf('site_id=')) {
                props.history.push('/article/edit/' + r.id)
            }
            article.site?.published &&
                fetch('https://' + article.site.url + '/fc')
                    .then()
                    .catch(() => console.warn('flush cache called on https://', article.site.url))
        })
        return false
    }

    const saveDraft = () => {
        last_saved_diff_id = uuidv4()
        diff_id = last_saved_diff_id
        // console.log({last_saved_diff_id}, {diff_id})
        setDraftStatus('loading')
        // console.log(form_data)
        const url = 'article_draft'
        const request = post

        const data = { ...form_data }
        let body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body
        const hasParent = (block) => body.find((item) => item.type === 'root' || (item.block_id_array && ~item.block_id_array.indexOf(block.id)))
        body = body.filter(hasParent)
        data.body = body.filter(Boolean).map((block) => {
            let _block = block
            if (block && block.payload) {
                _block = { ...block, payload: undefined }
            }
            return _block
        })
        const payload = {
            ...Object.keys(data).reduce((acc, key) => {
                if (typeof data[key] === 'object') {
                    acc[key] = JSON.stringify(data[key])
                } else {
                    acc[key] = data[key]
                }
                return acc
            }, {}),
            draft: 1,
        }
        payload.article_id = id
        delete payload.id
        console.log('saving draft', payload)
        request(url, payload).then((r) => {
            setDraftStatus('saved')
            setNeedsToBeSaved(false)
            setArticle({
                ...article,
                body: r.body,
                title: r.title,
                description: r.description,
                permalink: r.permalink,
                updated_at: r.updated_at,
                article_draft: r,
                article_draft_array: [...(article.article_draft_array || []), r],
            })
        })
        return false
    }
    const addToProductBucket = useCallback(
        (item) => {
            const new_product_bucket_array = [...product_bucket_array, item]
            setProductBucketArray(new_product_bucket_array)
            if (!query_history.some((query) => query.id === item.query_id)) {
                const new_query_history = [...query_history, { id: item.query_id, ...item.query }]
                setQueryHistory(new_query_history)
                localStorage.setItem('query_history', JSON.stringify(new_query_history))
            }
            localStorage.setItem('product_search_array', JSON.stringify(new_product_bucket_array))
            console.log({ item }, product_bucket_array)
        },
        [product_bucket_array, query_history]
    )
    const removeQueryHistory = useCallback(
        (id) => {
            console.log(id)
            const new_history = [...query_history.filter((item) => item.id !== id)]
            setQueryHistory(new_history)
            localStorage.setItem('query_history', JSON.stringify(new_history))

            const new_product_search_array = [...product_bucket_array.filter((item) => item.query_id !== id)]
            setProductBucketArray(new_product_search_array)
            localStorage.setItem('product_search_array', JSON.stringify(new_product_search_array))
        },
        [query_history]
    )
    const removeProductSearch = useCallback(
        (image_url) => {
            console.log(image_url)
            const new_product_search_array = [...product_bucket_array.filter((item) => item.image_url !== image_url)]
            setProductBucketArray(new_product_search_array)
            localStorage.setItem('product_search_array', JSON.stringify(new_product_search_array))
        },
        [product_bucket_array]
    )
    const Header = (props) => (
        <div className="w-100 resource-bucket-controlled-width">
            <div onClick={(e) => setAmazonSelectorVisible(!display_amazon_selector)} className="btn btn-amazon btn-lg w-100 mb-3">
                <Icon name="amazon" className="pointer" /> Search Amazon
            </div>
        </div>
    )

    const article_draft = article.article_draft || {}
    const body_property = form_definition.find((property) => property.name === 'body')

    const { usage } = useTranslation()
    const [translationUsage, setTranslationUsage] = useState(null)
    const refreshTranslationUsage = () => {
        usage().then((r) => setTranslationUsage({ usage: r.data.character_count, max: r.data.character_limit }))
    }
    useEffect(() => {
        if (article.translated_from__article_id) {
            refreshTranslationUsage()
        }
    }, [article.translated_from__article_id])

    const [onSaveArray, setOnSaveArray] = useState([])
    const [displayTranslationUI, setDisplayTranslationUI] = useState(true)

    const [translationContext, setTranslationContext] = useState({})
    const [productSwapInfo, setProductSwapInfo] = useState(null)

    return (
        <React.Fragment>
            <TranslationContext.Provider value={useMemo(() => ({ ...translationContext, setTranslationContext }), [translationContext])}>
                <ArticleResourcesContent>
                    <ArticleEditContext.Provider
                        value={useMemo(
                            () => ({
                                site: article.site,
                                article,
                                display_amazon_selector,
                                setAmazonSelectorVisible,
                                refreshTranslationUsage,
                                translateText,
                                setOnSaveArray,
                                displayTranslationUI,
                                setDisplayTranslationUI,
                                unavailableLinkData,
                                clickData,
                                productSwapInfo,
                                setProductSwapInfo,
                            }),
                            [article, display_amazon_selector, onSaveArray, displayTranslationUI, unavailableLinkData?.data, clickData?.data]
                        )}
                    >
                        <Prompt when={last_saved_diff_id !== diff_id} message="You have unsaved changes, are you sure you want to leave?" />
                        {/* <div className="container">
                        <div className="row">
                            <div className="col">

                            </div>
                        </div>
                    </div> */}
                        {(status === 'fetching' && <Loading text="Fetching article data" />) || null}
                        {status !== 'fetching' && (
                            <div className={'row' + (displayTranslationUI ? ' display-translation-ui' : '')}>
                                {/* <div className="col alt-hidden" id="article-highlighter-container">
                                
                            </div> */}
                                <div className="container">
                                    <form onSubmit={save}>
                                        <div className="row">
                                            <div className="col-md-9 col-xxl-6 offset-xxl-1">
                                                {/* <Breadcrumb breadcrumb_data={breadcrumb_data} /> */}

                                                <div className="row">
                                                    <div className="col-8">
                                                        {form_definition.map((property) => {
                                                            if (property.name !== 'body') {
                                                                if (property.name === 'old_permalink') {
                                                                    if (!article.site?.from_wordpress) {
                                                                        return null
                                                                    }
                                                                }
                                                                return (
                                                                    <FormGroup key={`form-group-${property.name}`}>
                                                                        <Label for={`object-edit-${property.name}`}>{property.label}</Label>
                                                                        {(property.type !== 'image' && (
                                                                            <Input
                                                                                type={property.type || 'text'}
                                                                                {...property}
                                                                                name={`${property.name}`}
                                                                                id={`object-edit-${property.name}-${id}`}
                                                                                article={article}
                                                                                product_bucket_array={product_bucket_array}
                                                                                value={form_data[property.name]}
                                                                                onChange={setFormDataState}
                                                                                unavailable_link_array={unavailable_link_array || undefined}
                                                                            />
                                                                        )) || (
                                                                            <Input
                                                                                type={'image'}
                                                                                {...property}
                                                                                name={`${property.name}`}
                                                                                id={`object-edit-${property.name}-${id}`}
                                                                                article={article}
                                                                                product_bucket_array={product_bucket_array}
                                                                                value={form_data[property.name]}
                                                                                parent_model={model}
                                                                                parent_id={id}
                                                                                parent={article}
                                                                                onChange={setFormDataState}
                                                                                content={form_data[property.name]}
                                                                                image_key={property.key || undefined}
                                                                            />
                                                                        )}
                                                                    </FormGroup>
                                                                )
                                                            }
                                                            return null
                                                        })}
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="sticky-toolbar">
                                                            <Button
                                                                className={
                                                                    'w-100 mb-1 text-uppercase ' + ((needs_to_be_saved && 'btn-success') || 'btn-primary')
                                                                }
                                                                disabled={status === 'loading' || draft_status === 'loading'}
                                                            >
                                                                <If true={status === 'ready'}> Save Article</If>
                                                                <If true={status === 'loading'}>
                                                                    <span>
                                                                        Saving <i className="fal fa-circle-notch fa-spin" />
                                                                    </span>
                                                                </If>
                                                                <If true={status === 'saved'}>
                                                                    <span>
                                                                        Saved <i className="fal fa-check" />
                                                                    </span>
                                                                </If>
                                                            </Button>
                                                            <If true={!!article.user}>
                                                                <small className="d-block">Saved by {article.user && article.user.name}</small>
                                                            </If>
                                                            <If true={!!article.updated_at}>
                                                                <small className="d-block">
                                                                    on the{' '}
                                                                    {(isValid(parseISO(article.updated_at)) &&
                                                                        format(parseISO(article.updated_at), "do 'of' MMMM yyyy, HH:mm:ss")) ||
                                                                        null}
                                                                </small>
                                                            </If>
                                                            <div
                                                                className={
                                                                    'mt-3 mb-1 w-100 btn text-uppercase ' +
                                                                    ((needs_to_be_saved && 'btn-dark') || 'btn-secondary')
                                                                }
                                                                disabled={status === 'loading' || draft_status === 'loading'}
                                                                onClick={saveDraft}
                                                            >
                                                                <If true={draft_status === 'ready'}> Save New Draft</If>
                                                                <If true={draft_status === 'loading'}>
                                                                    <span>
                                                                        Saving <i className="fal fa-circle-notch fa-spin" />
                                                                    </span>
                                                                </If>
                                                                <If true={draft_status === 'saved'}>
                                                                    <span>
                                                                        Draft Saved <i className="fal fa-check" />
                                                                    </span>
                                                                </If>
                                                            </div>
                                                            <If true={article_draft}>
                                                                <small className="d-block">
                                                                    Draft #{article_draft.id} saved by {article_draft.user && article_draft.user.name}
                                                                </small>
                                                            </If>
                                                            <If true={article_draft && !!article_draft.updated_at}>
                                                                <small className="d-block">
                                                                    on the{' '}
                                                                    {(isValid(parseISO(article.updated_at)) &&
                                                                        format(parseISO(article.updated_at), "do 'of' MMMM yyyy, HH:mm:ss")) ||
                                                                        null}
                                                                </small>
                                                            </If>
                                                            <If true={get_article_draft_id}>
                                                                <div>
                                                                    <span className="badge badge-danger w-100">
                                                                        Currently viewing draft #{get_article_draft_id}
                                                                    </span>
                                                                    <small>
                                                                        <a href={`/article/edit/${article.id}`}>View the original version</a>
                                                                    </small>
                                                                </div>
                                                            </If>
                                                            {/* {translation_usage} */}
                                                            {/* <div>
                                                            { cached_version && <span>Cached version available. Click <span onClick={restoreCachedVersion}>here</span> to restore.</span> || null }
                                                        </div> */}
                                                            <hr />
                                                            <small>
                                                                {(article.article_draft_array || []).length} draft
                                                                {((article.article_draft_array || []).length !== 1 && 's') || null} -{' '}
                                                                {(!expanded_draft_list && (
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault()
                                                                            setExpandedDraftList(true)
                                                                        }}
                                                                    >
                                                                        View Draft list
                                                                    </a>
                                                                )) || (
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault()
                                                                            setExpandedDraftList(false)
                                                                        }}
                                                                    >
                                                                        Hide Draft list
                                                                    </a>
                                                                )}
                                                            </small>
                                                            {(expanded_draft_list && article.article_draft_array && (
                                                                <React.Fragment>
                                                                    <div style={{ maxHeight: '400px', overflow: 'scroll' }}>
                                                                        <small>
                                                                            <table className="table table-striped">
                                                                                <tbody>
                                                                                    {article.article_draft_array.map((article_draft) => (
                                                                                        <tr key={article_draft.id}>
                                                                                            <td>
                                                                                                <strong>#{article_draft.id}</strong> -{' '}
                                                                                                <a
                                                                                                    href={`/article/edit/${article.id}?article_draft_id=${article_draft.id}`}
                                                                                                >
                                                                                                    View Draft
                                                                                                </a>
                                                                                                <br />
                                                                                                <small>
                                                                                                    {(isValid(parseISO(article_draft.updated_at)) &&
                                                                                                        format(
                                                                                                            parseISO(article_draft.updated_at),
                                                                                                            "do 'of' MMMM yyyy, HH:mm:ss"
                                                                                                        )) ||
                                                                                                        null}
                                                                                                    <br />
                                                                                                    size: {article_draft.length}
                                                                                                </small>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </small>
                                                                    </div>
                                                                </React.Fragment>
                                                            )) ||
                                                                null}
                                                            <hr />
                                                            {/* <Input
                                                                type="select"
                                                                options={ARTICLE_STATUS_ARRAY}
                                                                onChange={setArticleStatus}
                                                                value={article.status_id === '' ? '0' : article.status_id}
                                                            /> */}
                                                            <ArticleStatus status_id={article.status_id} setArticleStatus={setArticleStatus} />
                                                            <hr />
                                                            <Switch
                                                                onChange={setPublished}
                                                                checked={!!article.published}
                                                                className="float-right"
                                                                htmlFor="article-published"
                                                            />
                                                            <label htmlFor={`article-published`} className="mb-0">
                                                                Published
                                                            </label>
                                                            <hr />
                                                            <MissingTranslationButton />
                                                            {(translationUsage && (
                                                                <div className="mt-3">
                                                                    <strong>Translation usage</strong>
                                                                    <div className="progress">
                                                                        <div
                                                                            className="progress-bar"
                                                                            role="progressbar"
                                                                            style={{
                                                                                width: (translationUsage.usage / translationUsage.max) * 100 + '%',
                                                                            }}
                                                                        >
                                                                            {((translationUsage.usage / translationUsage.max) * 100).toFixed(2)}%
                                                                        </div>
                                                                    </div>
                                                                    <small>
                                                                        {translationUsage.usage} / {translationUsage.max} characters
                                                                    </small>
                                                                </div>
                                                            )) ||
                                                                null}
                                                            {(translationContext.getHrefFromExternalIdArray?.length && (
                                                                <>
                                                                    <HrefFromAsinButton />
                                                                </>
                                                            )) ||
                                                                null}
                                                            {(translationContext.translateImageCaptionArray?.length && (
                                                                <>
                                                                    <TranslateImageCaption />
                                                                </>
                                                            )) ||
                                                                null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <Input
                                                    type={body_property.type || 'text'}
                                                    {...body_property}
                                                    name={`${body_property.name}`}
                                                    id={`object-edit-${body_property.name}-${id}`}
                                                    article={article}
                                                    site={article.site}
                                                    product_bucket_array={product_bucket_array}
                                                    value={form_data[body_property.name]}
                                                    onChange={setFormDataState}
                                                    unavailable_link_array={unavailable_link_array || undefined}
                                                    status={status}
                                                    needs_to_be_saved={needs_to_be_saved}
                                                />
                                            </div>
                                            <div className="col-md-3 col-xxl-5">
                                                {/* <div className="sticky-toolbar"> */}
                                                <div className="col-sticky resource-bucket-controlled-width">
                                                    {/* <nav className='nav nav-tabs'>
                                                    <li className='nav-item'>
                                                        <a className={'nav-link' + ((tab === 'amazon' && ' active') || '')} href='#' onClick={e => e.preventDefault() || setTab('amazon')}>
                                                            <Icon name='amazon' /> Amazon
                                                        </a>
                                                    </li>
                                                    <li className='nav-item'>
                                                        <a className={'nav-link' + ((tab === 'resources' && ' active') || '')} href='#' onClick={e => e.preventDefault() || setTab('resources')}>
                                                            Resources
                                                        </a>
                                                    </li>
                                                </nav>
                                                <ProductBucket
                                                    className={(tab !== 'amazon' && 'd-none') || undefined}
                                                    article.={article.site}
                                                    setAmazonSelectorVisible={setAmazonSelectorVisible}
                                                    display_amazon_selector={display_amazon_selector}
                                                    setQueryHistory={setQueryHistory}
                                                    removeQueryHistory={removeQueryHistory}
                                                    query_history={query_history}
                                                    removeProductSearch={removeProductSearch}
                                                    article={article}
                                                    product_bucket_array={product_bucket_array}
                                                />
                                                <ArticleResourcesColumn className={(tab !== 'resources' && 'd-none') || undefined} Header={Header} resources={article.resources || []} site={article.site} /> */}
                                                    <ArticleResourcesColumn
                                                        dd={true}
                                                        Header={Header}
                                                        article_id={id}
                                                        resources={article.resources || []}
                                                        site={article.site}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* <div className="col alt-hidden"> */}
                                <AmazonSelector
                                    setAmazonSelectorVisible={setAmazonSelectorVisible}
                                    display_amazon_selector={display_amazon_selector}
                                    setQueryHistory={setQueryHistory}
                                    removeQueryHistory={removeQueryHistory}
                                    query_history={query_history}
                                    removeProductSearch={removeProductSearch}
                                    site_id={article.site_id}
                                    ItemClickCallback={addToProductBucket}
                                />
                                {/* </div> */}
                            </div>
                        )}
                    </ArticleEditContext.Provider>
                </ArticleResourcesContent>
            </TranslationContext.Provider>
        </React.Fragment>
    )
}

const dummyFn = () => {}

const HrefFromAsinButton = () => {
    const { getHrefFromExternalIdArray } = useContext(TranslationContext)
    const [isLoading, setIsLoading] = useState(false)

    const getHrefFromExternalId = async () => {
        setIsLoading(true)
        for (const trDef of getHrefFromExternalIdArray) {
            await trDef.Fn()
        }
        setIsLoading(false)
    }
    return (
        <Button className="btn-warning text-uppercase w-100 mt-2" onClick={getHrefFromExternalId} isLoading={isLoading}>
            {getHrefFromExternalIdArray?.length} Href from ASIN
        </Button>
    )
}
const TranslateImageCaption = () => {
    const { translateImageCaptionArray } = useContext(TranslationContext)
    const [isLoading, setIsLoading] = useState(false)

    const translateImageCaption = async () => {
        setIsLoading(true)
        for (const trDef of translateImageCaptionArray) {
            await trDef.Fn()
        }
        setIsLoading(false)
    }
    return (
        <Button className="btn-secondary text-uppercase w-100 mt-2" onClick={translateImageCaption} isLoading={isLoading}>
            <i className="fal fa-globe-europe mr-2" /> {translateImageCaptionArray?.length} Image captions
        </Button>
    )
}

const MissingTranslationButton = function MissingTranslationButton() {
    const missing_translation_button = document.querySelector('.missing-translation')
    // console.log({ missing_translation_button })

    const triggerMissingTranslations = missing_translation_button
        ? () => {
              const target_button_array = [...document.querySelectorAll('.missing-translation')].map((i) => i.click())
          }
        : dummyFn

    return (
        (missing_translation_button && (
            <>
                <Button className="btn-warning text-uppercase w-100" type="button" onClick={triggerMissingTranslations}>
                    Translate missing
                </Button>
            </>
        )) ||
        null
    )
}

export default ArticleEdit
